import { render, staticRenderFns } from "./pointTime.vue?vue&type=template&id=2e8fe99a&scoped=true&"
import script from "./pointTime.vue?vue&type=script&lang=js&"
export * from "./pointTime.vue?vue&type=script&lang=js&"
import style0 from "./pointTime.vue?vue&type=style&index=0&id=2e8fe99a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fe99a",
  null
  
)

export default component.exports